<!-- **
  * name1 value1 name2 value2
* -->
<template>
    <div :class="classObject">
        <div v-for="(v, index) in listData" :key="`${v.name}-${index}`">
            <div v-if="!combineNameUnit" class="itemName"
                :style="{ color: v.colorName ?? v.colorName, fontSize: v.fontSize ?? v.fontSize }" :title=v.name>{{
                    v.name }}</div>
            <div v-else-if="!!v.unit" class="itemName"
                :style="{ color: v.colorName ?? v.colorName, fontSize: v.fontSize ?? v.fontSize }"
                :title="`${v.name}(${v.unit})`">
                {{ `${v.name}(${v.unit})` }}
            </div>
            <div v-else class="itemName" :style="{ color: v.colorName ?? v.colorName, fontSize: v.fontSize ?? v.fontSize }"
                :title=v.name>
                {{ v.name }}
            </div>
            <div v-if="!combineNameUnit && !!v.unit" class="itemUnit" :style="{ color: v.colorUnit ?? v.colorUnit }">({{
                v.unit }})
            </div>

            <div class="itemValue" :style="{ marginLeft: 10, color: v.colorValue ?? v.colorValue }" :title=v.value>{{
                dealBigNum(v.value) }}
            </div>
        </div>
    </div>
</template>

<script>
const classNames = require('classnames')
import { dealBigNum } from "@/assets/js/utils";
export default {
    name: 'TitleTipsItem',
    props: {
        listData: {
            type: Array,
            default: () => [{
                name: '开启',
                value: 0,
                colorValue: '#28CCCB'
            }, {
                name: '关闭',
                value: 0,
            }]
        },
        modalFlag: {
            type: Number,
            default: 0,
        },   //0是作为titleTips里面引用，1是直接引用单行使用，2是直接引用多行使用
        twoLine: {
            type: Boolean,
            default: false,
        },
        className: {
            type: String,
            default: ""
        },
        combineNameUnit: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classObject: function () {
            return classNames({
                'TitleTipsItem': !this.modalFlag,
                'directModal': this.modalFlag == 1,
                'twoLine': this.modalFlag == 2,
                [this.className]: !!this.className,
            })
        }
    },
    methods: {
        dealBigNum
    },
}
</script>

<style lang="scss" scoped>
.TitleTipsItem {
    @include setFlexStart;
    max-width: 270px;

    &>div {
        color: #000;
        display: flex;
        max-width: 140px;
        margin-left: 5px;

        .itemName {
            width: 30px;
            min-width: 30px;
        }

        .itemValue {
            font-weight: bold;
            max-width: 100px;
            margin-left: 5px;
            @include setEllipsis;
        }
    }
}

.directModal {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;

    &>div {
        // font-weight: bold;
        color: #000;
        display: flex;
        width: 206px;
        height: 50%;
        max-width: 1.041667rem;
        align-items: center;
        justify-content: flex-start;
        align-content: center;

        .itemName {
            width: max-content;
            max-width: 90px;
            @include setEllipsis;
        }

        .itemUnit {
            max-width: 60px;
        }

        .itemValue {
            font-weight: bold;
            max-width: 50px;
            margin-left: 5px;
            @include setEllipsis;
        }
    }
}

.twoLine {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    width: 100%;

    &>div {
        // font-weight: bold;
        color: #666;
        display: flex;
        width: 206px;
        height: 50%;
        max-width: 1.041667rem;
        align-items: center;
        justify-content: flex-start;
        align-content: center;

        .itemName {
            width: max-content;
            max-width: 90px;
            @include setEllipsis;
        }

        .itemUnit {
            max-width: 60px;
        }

        .itemValue {
            color: #333;
            font-weight: bold;
            max-width: 50px;
            margin-left: 5px;
            @include setEllipsis;
        }
    }
}</style>